import ShortVideoHero from "./short-video-hero";
import ShortVideoPopup from "./short-video-popup";
// import ShortVideoSmall from "./short-video-small";
import StandardYoutubeVideo from "./standard-yt-video";

let youtubeApiReady = false;

const YouTube = {
  init: function () {
    if (!youtubeApiReady) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      youtubeApiReady = true;
    }

    window.onYouTubeIframeAPIReady = function () {
      ShortVideoPopup.render();
      ShortVideoHero.render();
      // ShortVideoSmall.render();
      StandardYoutubeVideo.render();
    };
  },
};

export default YouTube;